import { render, staticRenderFns } from "./index.vue?vue&type=template&id=56a37fa2"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=56a37fa2&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\lptni\\开发\\dev\\project\\unbox-server\\vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56a37fa2')) {
      api.createRecord('56a37fa2', component.options)
    } else {
      api.reload('56a37fa2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=56a37fa2", function () {
      api.rerender('56a37fa2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/memberTourists/list/index.vue"
export default component.exports